/*
 * Запуск кода после того, как пришёл полный app.css.
 *
 * Нужен для режима app.inline_styles (config/services.yaml, сейчас выключен); пока app.css
 * подключён обычным блокирующим тегом, ждать нечего, и код запускается сразу.
 *
 * В том режиме страница рисуется по стилям, встроенным в HTML: это правила для разметки,
 * которая в ней есть (App\Service\CriticalCss). Сам app.css подключён без блокировки —
 * media="print" до загрузки — и приходит чуть позже. Разметку, которую создаёт скрипт
 * (Vue-формы, плеер video.js, служебные классы Swiper), встроенные стили не покрывают,
 * поэтому такой скрипт стартует отсюда: иначе его блок на мгновение появится без
 * оформления и сдвинет страницу.
 *
 * Если файл не пришёл вовсе (ошибка сети), код всё равно запускается — по событию error
 * или через пять секунд: неоформленная форма лучше отсутствующей.
 */
export const whenStylesReady = (fn) => {
  const pending = [...document.querySelectorAll('link[rel="stylesheet"][media="print"][onload]')];
  if (!pending.length) {
    fn();
    return;
  }

  let left = pending.length;
  let started = false;
  const start = () => {
    if (!started) {
      started = true;
      fn();
    }
  };
  const settle = () => {
    left -= 1;
    if (left === 0) {
      start();
    }
  };

  pending.forEach((link) => {
    // обработчик из атрибута onload (он и включает файл) назначен раньше и сработает первым
    link.addEventListener('load', settle, { once: true });
    link.addEventListener('error', settle, { once: true });
  });
  setTimeout(start, 5000);
};
